__turbopack_context__.v({
  "button": "processing-module-scss-module__y7RMlG__button",
  "icon": "processing-module-scss-module__y7RMlG__icon",
  "processing": "processing-module-scss-module__y7RMlG__processing",
  "title": "processing-module-scss-module__y7RMlG__title",
});
